import React from "react";
import { toTailwindNumericValue } from "../utils/utils";
function SpaceValuesRow(props) {
  const { value, prefix } = props;
  return (
    <div
      className={`p-2 w-full rounded  flex justify-between items-center ${
        value.nearest === true
          ? "bg-gray-900 shadow text-gray-400"
          : "text-gray-500"
      }`}
    >
      <div className="space-x-2">
        <span className="font-bold">
          {toTailwindNumericValue(prefix, value)}
        </span>
        <span className="text-sm text-gray-600">
          {value.value}
          {value.unit}
        </span>
        <span className="text-sm text-gray-600">{value.pxValue}px</span>
      </div>
    </div>
  );
}

export default SpaceValuesRow;
